

export const breackfast = 
[{
    id:11,
    product: "Café Americano",
    precio: 25
},
    {
        id:12,
        product: "Café con leche",
        precio: 27
    },
    {
        id:13,
        product: "Jugo de frutas",
        precio: 27
    },
    {
        id:14,
        product: "Té",
        precio: 15
    },
    {
        id:15,
        product: "Sandwich jamón y queso",
        precio: 20
    },
    {
        id:16,
        product: "Hot Cakes",
        precio : 25
    },
    {
        id:17,
        product: "Coctel de frutas",
        precio: 20
    }
]

export const burgersTime =
[{
    id:1,
    product: "Agua de frutas",
    precio: 15
},
    {
        id:2,
        product: "Refresco",
        precio: 20
    },
    {
        id:3,
        product: "Cerveza",
        precio: 25
    },
    {
        id:4,
        product: "Cerveza Artesanal",
        precio: 40
    },
    {
        id:5,
        product: "Hamburguesa Simple",
        precio: 30,
        flavor: [{id:"5A",op:"Carne de Res"},{id:"5B",op:"Carne de Pollo"},{id:"5C",op:"Vegetariana"}]
    },
    {
        id:6,
        product: "Hamburguesa doble",
        precio : 40,
        flavor: [{id:"6A",op:"Carne de Res"},{id:"6B",op:"Carne de Pollo"},{id:"6C",op:"Vegetariana"}]
    },
    {
        id:7,
        product: "Hot Dog",
        precio: 25
    },
    {
        id:8,
        product: "Papas fritas",
        precio:20
    },
    {
        id:9,
        product: "Aros de cebolla",
        precio: 15
    },
    {
        id:10,
        product: "Nachos",
        precio: 25
    }
]







